import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import SubscribeEventsToggle from 'modules/event-notifications/subscribe-events-toggle/index.js';
import SubscribeEventsOnboarding from 'modules/event-notifications/subscribe-events-onboarding/index.js';

const {
    selectors: {
        selectIsOnboardingAcknowledged,
        selectIsEventSubscribed,
        selectIsServiceAvailable,
        selectIsEventEligible,
    },
    actions: notificationsActions,
} = MojitoServices.SportsContent.ContentNotifications;
const { FlexPane, Button, DotNotification, Image, Popup } = MojitoPresentation.Components;

const EventNotificationSubscriber = props => {
    const dispatch = useDispatch();
    const { mojitoTools, eventId } = props;
    const { config, appContext } = mojitoTools;
    const { isServiceAvailable, isAcknowledged, isEventSubscribed, isEventEligible } = useSelector(
        state =>
            selectIsServiceAvailable()
                ? {
                      isServiceAvailable: true,
                      isAcknowledged: selectIsOnboardingAcknowledged(state),
                      isEventSubscribed: selectIsEventSubscribed(eventId, state),
                      isEventEligible: selectIsEventEligible(eventId, state),
                  }
                : {},
        shallowEqual
    );
    useEffect(() => {
        dispatch(notificationsActions.loadFromExternalState());
    }, [dispatch]);

    const [isToggleOn, setToggleOn] = useState(false);

    // Notifications are not supported
    if (!isServiceAvailable || !isEventEligible) {
        return null;
    }

    const toggleNotification = () => {
        setToggleOn(!isToggleOn);
        !isAcknowledged && dispatch(notificationsActions.acknowledgeOnboarding());
        const { emitAnalytics } = appContext.analyticsEmitter;
        emitAnalytics('notificationsSubscriberClick');
    };

    const onOutsideClick = () => setToggleOn(false);
    const showPopup = isToggleOn || !isAcknowledged;

    return (
        <FlexPane config={config.container}>
            <Button
                onClick={toggleNotification}
                config={config.subscribeNotificationButton}
                class="ta-SubscribeEvents-Button"
            >
                <Image class="ta-bellIcon" config={config.bellIcon} />
                <DotNotification config={config.dotNotification} isVisible={isEventSubscribed} />
            </Button>
            {showPopup && (
                <Popup
                    visible={true}
                    onOutsideClick={onOutsideClick}
                    config={config.notificationPopup}
                    captureOutsideClicks={showPopup && isAcknowledged}
                >
                    {isAcknowledged ? (
                        <SubscribeEventsToggle
                            config={config.subscribeEventsToggle}
                            l10nKeyLabel={'$EVENT_NOTIFICATION_SUBSCRIBER.NOTIFICATION.DESCRIPTION'}
                            eventIds={[eventId]}
                            hideBellIcon={true}
                        />
                    ) : (
                        <SubscribeEventsOnboarding />
                    )}
                </Popup>
            )}
        </FlexPane>
    );
};

export default EventNotificationSubscriber;
